import React from 'react';

import { colors, fonts, container, eyebrow, sectionHeading, line } from '../theme';
import { appScreens } from '../data';

export default function InsideTheApp() {
  return (
    <section id="app" style={{ position: 'relative', borderTop: line.faint, overflow: 'hidden' }}>
      {/* ambient glows */}
      <div
        style={{
          position: 'absolute',
          top: '46%',
          left: '50%',
          transform: 'translate(-50%,-50%)',
          width: 980,
          height: 980,
          background: 'radial-gradient(circle,rgba(49,56,236,.16),transparent 62%)',
          pointerEvents: 'none',
        }}
      />
      <div
        style={{
          position: 'absolute',
          top: '60%',
          left: '78%',
          transform: 'translate(-50%,-50%)',
          width: 520,
          height: 520,
          background: 'radial-gradient(circle,rgba(232,99,43,.12),transparent 64%)',
          pointerEvents: 'none',
        }}
      />

      <div className="lyfe-wrap lyfe-sec" style={{ ...container, position: 'relative', padding: '130px 40px 120px' }}>
        <div className="lyfe-reveal" style={{ maxWidth: 680, margin: '0 auto 76px', textAlign: 'center' }}>
          <div style={eyebrow(colors.blue)}>Inside the app</div>
          <h2 className="lyfe-h2" style={sectionHeading}>
            The whole night,
            <br />
            in your pocket.
          </h2>
          <p style={{ fontSize: 18, lineHeight: 1.55, color: colors.muted, margin: '24px auto 0', maxWidth: 480 }}>
            From the map of what's live to claiming a free drink and pulling up the crew — it all happens in a few taps.
          </p>
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', gap: 40, flexWrap: 'wrap' }}>
          {appScreens.map((s) => (
            <div key={s.n} className="lyfe-reveal" style={{ width: 268, flex: 'none', textAlign: 'center' }}>
              <div
                style={{
                  borderRadius: 44,
                  background: colors.bgDeep,
                  padding: 7,
                  border: s.featured ? '1px solid rgba(87,96,242,.4)' : '1px solid rgba(255,255,255,.12)',
                  boxShadow: s.featured
                    ? '0 44px 100px rgba(49,56,236,.28),0 40px 90px rgba(0,0,0,.6)'
                    : '0 40px 90px rgba(0,0,0,.6)',
                }}>
                <img src={s.img} alt={s.alt} style={{ width: '100%', display: 'block', borderRadius: 38 }} />
              </div>
              <div style={{ fontFamily: fonts.serif, fontStyle: 'italic', fontSize: 17, color: colors.muted2, marginTop: 14 }}>
                {s.n}
              </div>
              <div style={{ fontSize: 16, color: colors.inkSoft, marginTop: 6 }}>{s.caption}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
